<template>
  <b-row
    :class="customChange ? 'list-group-item' : ''"
  >
    <b-col
      md="12"
      xl="12"
    >
      <b-card>
        <b-card-header
          class="base-document-header"
        >
          <b-card-title>{{ $t('DEBTIA_PAYMENTS') }}</b-card-title>
          <b-card-title class="text-primary">
            <!-- <drag-links
              :parent="3"
              :side="side"
              :custom-change="customChange"
            /> -->
          </b-card-title>
        </b-card-header>
        <b-table
          v-if="paymentsData.length > 0"
          :fields="paymentsTableFields"
          :items="paymentsData"
          striped
          responsive
        >
          <template #cell(id)="row">
            {{ row.item.systemId }}
          </template>
          <template #cell(Amount)="row">
            {{ getDKKConvertedAmount(row.item.Amount) }}
          </template>
          <template #cell(remainingAmount)="row">
            {{ getDKKConvertedAmount(row.item.remainingAmount) }}
          </template>
        </b-table>
        <b-alert
          v-else
          variant="warning"
          show
        >
          <div class="alert-body">
            {{ $t('DEBTIA_NO_PAYMENTS_MSG') }}
          </div>
        </b-alert>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BAlert, BTable, BCardHeader, BCardTitle,
} from 'bootstrap-vue'
// import store from '@/store'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import i18n from '@/libs/i18n'
// import DragLinks from '../DragLinks.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BAlert,
    BTable,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BCardHeader,
    BCardTitle,
    // DragLinks,
  },
  directives: {
    Ripple,
  },
  props: {
    side: {
      type: String,
      required: true,
    },
    customChange: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      paymentsData: [],
      defaultCurrency: localStorage.getItem('defaultCurrency'),
      caseId: this.$route.params.id,
    }
  },
  computed: {
    paymentsTableFields() {
      return [
        { key: 'id', label: 'ID' },
        { key: 'postingDate', label: i18n.t('DEBTIA_PAYMENT_DATE') },
        { key: 'Amount', label: i18n.t('DEBTIA_AMOUNT') },
        { key: 'remainingAmount', label: i18n.t('DEBTIA_REMAINING_AMOUNT') },
      ]
    },
  },
  created() {
    this.getPayments()
  },
  methods: {
    async getPayments() {
      const url = `/debt-case/payments/${this.caseId}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.paymentsData = response.data.data
        }
      })
    },
    getDKKConvertedAmount(amount) {
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency: this.defaultCurrency }).format(parseFloat(amount).toFixed(2))
    },
  },
}
</script>

<style lang="scss">
</style>
